module.exports = __webpack_public_path__ + "assets/img/8_1414_big.88d6ba9b.jpg";